export function parseExperiments(experiments) {
    let result = [];

    if (experiments) {
        experiments.forEach(experiment => {
            let parsedExperiment = {};

            parsedExperiment.id = experiment.experimentId;
            parsedExperiment.type = experiment.experimentType;
            parsedExperiment.comments = experiment.comments;
            parsedExperiment.creationDate = experiment.creationDate;
            parsedExperiment.dataAcquisitionFilePath = experiment.dataAcquisitionFilePath;
            parsedExperiment.dataCollectionCount = experiment.dataCollectionCount;
            parsedExperiment.dataCollectionDoneCount = experiment.dataCollectionDoneCount;
            parsedExperiment.macromolecules = experiment.macromolecules;
            parsedExperiment.measurementAveragedCount = experiment.measurementAveragedCount;
            parsedExperiment.measurementCount = experiment.measurementCount;
            parsedExperiment.measurementDoneCount = experiment.measurementDoneCount;
            parsedExperiment.name = experiment.name;
            parsedExperiment.proposalId = experiment.proposalId;
            parsedExperiment.sessionId = experiment.sessionId;
            parsedExperiment.sourceFilePath = experiment.sourceFilePath;
            parsedExperiment.specimenCount = experiment.specimenCount;
            parsedExperiment.status = experiment.status;
            result.push(parsedExperiment);
        })
        return result;
    }
    return null;
}

/**
 * Mapper function which parse an experiment object
 * @param {*} experiment JSON stringified experiment
 */
export function parseExperiment(experiment) {
    debugger;
    if (experiment) {
        let parsedExperiment = {};
        parsedExperiment.experimentId = experiment.experimentId;
        parsedExperiment.creationDate = experiment.creationDate;
        if (experiment.samplePlate3VOs && experiment.samplePlate3VOs instanceof Array && experiment.samplePlate3VOs.length > 0) {
            // Handle sample plates
            let samplePlates = [];
            experiment.samplePlate3VOs.forEach(samplePlateItem => {
                let samplePlate = {};
                samplePlate.samplePlateId = samplePlateItem.samplePlateId;
                samplePlate.boxId = samplePlateItem.boxId;
                samplePlate.name = samplePlateItem.name;
                samplePlate.slotPositionRow = samplePlateItem.slotPositionRow;
                samplePlate.slotPositionColumn = samplePlateItem.slotPositionColumn;
                samplePlate.storageTemperature = samplePlateItem.storageTemperature;
                samplePlate.experimentId = samplePlateItem.experimentId;

                // Handle plate groups
                if (samplePlateItem.plategroup3VO) {
                    let plateGroup = {};
                    plateGroup.plateGroupId = samplePlateItem.plategroup3VO.plateGroupId;
                    plateGroup.storageTemperature = samplePlateItem.plategroup3VO.storageTemperature;
                    plateGroup.name = samplePlateItem.plategroup3VO.name;

                    samplePlate.plateGroup = plateGroup;
                }

                if (samplePlateItem.platetype3VO) {
                    let plateType3VO = samplePlateItem.platetype3VO;
                    let plateType = {};
                    plateType.plateTypeId = plateType3VO.plateTypeId;
                    plateType.name = plateType3VO.name;
                    plateType.description = plateType3VO.description;
                    plateType.rowCount = plateType3VO.rowCount;
                    plateType.columnCount = plateType3VO.columnCount;
                    plateType.shape = plateType3VO.shape;

                    samplePlate.plateType = plateType;
                }

                samplePlates.push(samplePlate);
            });
            parsedExperiment.samplePlates = samplePlates;
        }

        if (experiment.samples3VOs && experiment.samples3VOs instanceof Array && experiment.samples3VOs.length > 0) {
            let samples3VOs = experiment.samples3VOs;
            let samples = [];
            samples3VOs.forEach(samples3VO => {
                let sample = {}
                sample.specimenId = samples3VO.specimenId;
                if (samples3VO.macromolecule3VO) {
                    let macromolecule = {};
                    macromolecule.macromoleculeId = samples3VO.macromolecule3VO.macromoleculeId;
                    macromolecule.safetylevelId = samples3VO.macromolecule3VO.safetylevelId;
                    macromolecule.proposalId = samples3VO.macromolecule3VO.proposalId;
                    macromolecule.name = samples3VO.macromolecule3VO.name;
                    macromolecule.acronym = samples3VO.macromolecule3VO.acronym;
                    macromolecule.molecularMass = samples3VO.macromolecule3VO.molecularMass;
                    macromolecule.extintionCoefficient = samples3VO.macromolecule3VO.extintionCoefficient;
                    macromolecule.sequence = samples3VO.macromolecule3VO.sequence;
                    macromolecule.contactsDescriptionFilePath = samples3VO.macromolecule3VO.contactsDescriptionFilePath;
                    macromolecule.comments = samples3VO.macromolecule3VO.comments;
                    macromolecule.symmetry = samples3VO.macromolecule3VO.symmetry;
                    macromolecule.creationDate = samples3VO.macromolecule3VO.creationDate;
                    macromolecule.electronDensity = samples3VO.macromolecule3VO.electronDensity;
                    macromolecule.refractiveIndex = samples3VO.macromolecule3VO.refractiveIndex;
                    macromolecule.solventViscosity = samples3VO.macromolecule3VO.solventViscosity;

                    sample.macromolecule = macromolecule;
                }

                if (samples3VO.sampleplateposition3VO) {
                    let sampleplateposition3VO = samples3VO.sampleplateposition3VO;
                    let samplePlatePosition = {};
                    samplePlatePosition.samplePlatePositionId = sampleplateposition3VO.samplePlatePositionId;
                    samplePlatePosition.samplePlateId = sampleplateposition3VO.samplePlateId;
                    samplePlatePosition.rowNumber = sampleplateposition3VO.rowNumber;
                    samplePlatePosition.columnNumber = sampleplateposition3VO.columnNumber;
                    samplePlatePosition.volume = sampleplateposition3VO.volume;

                    sample.samplePlatePosition = samplePlatePosition;
                }
                samples.push(sample);
            });
            parsedExperiment.samples = samples;
        }

        return parsedExperiment;
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/helpers/Saxs/SaxsExperimentsMapper.js